import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import { SEQUENCES_LIST_KEY } from './useSequencesFolders';
import { FolderType } from 'types/sequences';
import useNotification from 'containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

interface Item {
  id: string;
  type: FolderType;
  destFolderId?: string;
}

interface Props {
  items: Item[];
}

export function useUpdateSequencesFolders() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['sequence']);

  const { mutateAsync } = useMutation<Props, any, Props>({
    mutationFn: ({ items }) =>
      request('/sequences/update-folders', {
        method: 'PATCH',
        body: {
          data: items,
        },
      }),

    onError: (_, sequenceId) => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY, sequenceId],
      });
      notifyError({
        title: t('sequence:messages.folder.updateError'),
      });
    },
    onSuccess: (_, { items }) => {
      items.forEach(item => {
        if (item.type === 'sequence') {
          queryClient.invalidateQueries({
            queryKey: [SEQUENCE_KEY, item.id],
          });
        }
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
  });
  return mutateAsync;
}
